export const SELECTION_DRAWER_WIDTH = "240px";
export const SELECTION_DRAWER_HEIGHT = "calc(100% - 64px)";
